// NetScouters OTT - Constantes globales

export const BRAND = {
  name: 'NetScouters OTT',
  short: 'NetScouters',
  tagline: 'La televisión del deporte base',
  description:
    'Directos y eventos multi-deporte para clubes, cantera y competiciones locales. Una experiencia de streaming moderna, rápida y pensada para móvil.',
  logoUrl:
    'https://customer-assets.emergentagent.com/job_scout-arch/artifacts/ghn7pgaw_netscouters%20logo%20general.png',
  heroBgUrl:
    'https://customer-assets.emergentagent.com/job_scout-arch/artifacts/jqfeuh8i_BANNER%20NEW.png',
  secondaryBannerUrl:
    'https://customer-assets.emergentagent.com/job_scout-arch/artifacts/roqblszc_banner%20tv.png',
};

export const SPORTS_LIST = [
  { slug: 'futbol', label: 'Fútbol' },
  { slug: 'baloncesto', label: 'Baloncesto' },
  { slug: 'voleibol', label: 'Voleibol' },
  { slug: 'balonmano', label: 'Balonmano' },
  { slug: 'hockey', label: 'Hockey' },
  { slug: 'futbol-sala', label: 'Fútbol sala' },
  { slug: 'rugby', label: 'Rugby' },
  { slug: 'beisbol', label: 'Béisbol' },
];

export const ROUTES = {
  home: '/',
  events: '/eventos',
  eventDetail: (slug) => `/eventos/${slug}`,
  eventWatch: (slug) => `/eventos/${slug}/watch`,
  clubs: '/clubes',
  clubDetail: (slug) => `/clubes/${slug}`,
  login: '/acceder',
  register: '/registro',
  forgot: '/recuperar',
  reset: '/restablecer',
  dashboard: '/dashboard',
  account: '/cuenta',
  admin: '/admin',
  adminUsers: '/admin/usuarios',
  adminUserDetail: (id) => `/admin/usuarios/${id}`,
  adminPlayerProfiles: '/admin/fichas-jugadores',
  adminPlayerProfileNew: '/admin/fichas-jugadores/nueva',
  adminPlayerProfileDetail: (id) => `/admin/fichas-jugadores/${id}`,
  adminLinkSuggestions: '/admin/sugerencias-vinculacion',
  // ---- Player Intelligence (Fase 1 · Mi rendimiento) ----
  // Rutas destino de los CTAs. Las páginas destino NO se construyen en esta
  // fase; se dejan preparadas para la siguiente aprobación explícita.
  playerIntelligenceMatch: (playerId, matchId) =>
    `/jugadores/${playerId}/analisis/${matchId}`,
  playerIntelligenceEvolution: (playerId) =>
    `/jugadores/${playerId}/evolucion`,
  legal: '/legal',
  privacy: '/privacidad',
  cookies: '/cookies',
};

export const PROFILE_TYPES = [
  {
    value: 'standard_user',
    label: 'Aficionado',
    description: 'Disfruta del deporte base como espectador.',
  },
  {
    value: 'parent_fan',
    label: 'Familiar / Aficionado',
    description: 'Padre, madre o familiar de un jugador.',
  },
  {
    value: 'player',
    label: 'Jugador / Jugadora',
    description: 'Compites en un club o cantera.',
  },
  {
    value: 'coach',
    label: 'Entrenador / Entrenadora',
    description: 'Diriges a un equipo o categoría.',
  },
  {
    value: 'scout',
    label: 'Scout / Captador',
    description: 'Buscas talento en cantera.',
  },
];

export const ACCOUNT_STATUS_LABELS = {
  active: 'Activa',
  pending_email_verification: 'Pendiente de verificación',
  pending_guardian_consent: 'Pendiente consentimiento tutor',
  suspended: 'Suspendida',
  deleted: 'Eliminada',
};

export const ACCOUNT_STATUS_TONE = {
  active: 'green',
  pending_email_verification: 'amber',
  pending_guardian_consent: 'amber',
  suspended: 'red',
  deleted: 'red',
};

export const ROLE_LABELS = {
  super_admin: 'Super admin',
  admin: 'Administrador',
  user: 'Usuario',
};
